export enum LOAN_STATE {
  ACTIVE = 'Active',
  RETURNED = 'Returned',
}

export interface Loan {
  id: string;
  fileId: string;
  productName: string;
  loanReference: string;
  state: string;
  loanDate: string;
  returnDate: string;
}
